// LIBS
import * as React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Image } from "@lululemon/ui-library";
// STYLES
import "./hover-image.scss";

const HoverImage = ({
  hoverSrc,
  className,
  isMobileDevice,
  showHoverImage,
  ...rest
}) => {
  const hoverImageClassNames = classNames({
    image__hover: !isMobileDevice,
    image__visible: isMobileDevice && showHoverImage,
    image__hidden: isMobileDevice && !showHoverImage,
  });

  const imageClassNames = classNames({
    image__default: !isMobileDevice && !!hoverSrc,
    image__visible: isMobileDevice && hoverSrc ? !showHoverImage : !hoverSrc,
    image__hidden: isMobileDevice && !!hoverSrc && showHoverImage,
  });

  return (
    <div className={classNames({ image: true })}>
      {hoverSrc && (
        <Image
          {...rest}
          src={hoverSrc}
          className={classNames(hoverImageClassNames, className)}
        />
      )}
      <Image {...rest} className={classNames(imageClassNames, className)} />
    </div>
  );
};

HoverImage.propTypes = {
  hoverSrc: PropTypes.string,
  className: PropTypes.string,
  isMobileDevice: PropTypes.bool.isRequired,
  showHoverImage: PropTypes.bool,
};

HoverImage.defaultProps = {
  hoverSrc: "",
  className: "",
  showHoverImage: false,
};

export default HoverImage;
